import * as React from 'react';
import cn from 'classnames';

import { CdnIconNames } from '../model/types';
import { useTheme } from '../../../../../theme';

interface Props {
	icon: CdnIconNames;
	className?: string;
}

const CdnIcon: React.FC<Props> = ({ icon, className }) => {
	const { CdnIcon: theme } = useTheme('Shared');

	return (
		<svg className={cn(theme.root, className)} data-icon={icon}>
			<use xlinkHref={`#${icon}`} />
		</svg>
	);
};

export default CdnIcon;
